<template>
    <span v-if="official" class="icon has-text-warning official-academy">
        <i class="fa fa-star" />
    </span>
</template>

<script>
    export default {
        name: "official-academy",
        props: ["official"],
    };
</script>
